export const permissionsNames = {
  projectManagerPosition: 'Менеджер УКИИ',
  fieldManagerPosition: 'Полевой ГИП'
}

export const permissionGroups = [
  {
    group: 'Справочник',
    code: 'books'
  },
  {
    group: 'Проект',
    code: 'contract'
  },
  {
    group: 'План-график',
    code: 'time_table'
  },
  {
    group: 'Реестр',
    code: 'contract_register'
  },
  {
    group: 'Опыт',
    code: 'experience'
  },
  {
    group: 'Судебные дела',
    code: 'law_cases'
  },
  {
    group: 'Запрос материалов',
    code: 'procedures'
  },
  {
    group: 'Отчеты',
    code: 'reports'
  },
  {
    group: 'Банковская гарантия',
    code: 'bank_guarantee'
  },
  {
    group: 'Распределение платежей',
    code: 'payment_distribution'
  }
]
